import axios from 'axios'
import AuthService from '@/services/auth'
import { i18n } from "../../../plugins/i18n"

const { t } = i18n.global
const authService = new AuthService()

export default {
    namespaced: true,
    state: {
        token: '',
        refreshToken: '',
        error: false,
        errorMessage: '',
        dataUser: ''
    },
    mutations: {
        setToken(state, payload) {
            state.token = payload.token
            state.refreshToken = payload.refreshToken
            state.error = false
        },
        logout(state) {
            state.token = ''
            state.refreshToken = ''
            state.error = false
        },
        authError(state, payload) {
            state.token = ''
            state.refreshToken = ''
            state.error = payload.error
            state.errorMessage = payload.errorMessage
        }
    },
    actions: {
        async signIn({commit}, user) {
            try {
                commit('setLoading', true, { root: true })
                const tokenResponse = await authService.getToken(user)
                commit('auth/setToken', {'token': tokenResponse.token, 'refreshToken': tokenResponse.refresh_token}, { root: true })
            } catch(e) {
                // necesito verificarlo de las dos formas
                const msg = e.response.status === 401 ? t('validations.wrong_pass') : (e.response?.data?.message) ? e.response.data.message : e.message
                commit('auth/authError', {'error': true, 'errorMessage': msg}, { root: true })
            } finally {
                commit('setLoading', false, { root: true })
            }
        },
        async signOut({commit, state}) {
            try {
                commit('setLoading', true, { root: true })
                await authService.setTokenExpired(state.token, state.refreshToken)
                commit('auth/logout', null, { root: true })
            } catch(e) {

            } finally {
                commit('setLoading', false, { root: true })
            }
        },
        async refreshToken({commit, state}) {
            try {
                const tokenResponse = await authService.refreshToken(state.token, state.refreshToken)
                commit('auth/setToken', {'token': tokenResponse.token, 'refreshToken': tokenResponse.refresh_token}, { root: true })
            } catch(e) {
                commit('auth/logout', null, { root: true })
            }
        },
        async switchRole({commit, state}, newRole) {
            try {
                commit('setLoading', true, { root: true })
                const response = await authService.switchRole(newRole, state.token, state.refreshToken)
                commit('auth/setToken', { 'token': response.token, 'refreshToken': response.refresh_token }, { root: true })
            } catch (e) {
                commit('auth/logout', null, { root: true })
            } finally {
                commit('setLoading', false, { root: true })
            }
        }
    }
}